export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Geothermal Energy Educator — London, United Kingdom',
    'My students finally understand the difference between geothermal geology, drilling systems, power generation technologies, and heating applications. I used to waste hours searching for the right way to explain how geothermal energy actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain geothermal resources, well engineering, thermal power plants, direct-use systems, or how to teach technical reasoning in geothermal contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Geothermal Energy and Renewable Systems Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated geothermal energy projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Geothermal Energy Educator | London, United Kingdom',
    "The material on geothermal geology and power generation completely changed how my students understand renewable energy. They finally grasp how thermal energy and drilling engineering enable sustainable electricity. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Geothermal Energy Teacher | Berlin, Germany',
    "The 50 geothermal energy projects transformed how my students see real-world applications. Now they analyze geothermal resources, understand drilling systems, evaluate power plant technologies, and grasp why geothermal knowledge matters professionally and in real renewable energy development. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The geothermal energy terminology handbook gave me back my class time. I used to spend time explaining geothermal concepts and misconceptions. Now I show the handbook and students instantly understand geothermal energy concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Geothermal Energy Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real geothermal challenges, evaluating resource potential, exploring technology applications, and understanding how technical reasoning contributes to sustainable energy transitions. This completely transformed how they see geothermal energy.",
  ],
];
